var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "item-edit" }, [
    _c("div", [
      _c("span", { staticClass: "font-weight-extra-bold" }, [_vm._v("Name:")]),
      _vm._v(
        "\n\t\t" +
          _vm._s(_vm.salutation) +
          " " +
          _vm._s(_vm.user.firstName) +
          " " +
          _vm._s(_vm.user.lastName) +
          "\n\t"
      )
    ]),
    _vm._v(" "),
    _c("div", [
      _c("span", { staticClass: "font-weight-extra-bold" }, [
        _vm._v("Mobilnummer:")
      ]),
      _vm._v("\n\t\t" + _vm._s(_vm._f("phone")(_vm.user.phone)) + "\n\t")
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }